type DastSpan = {
  type: "span",
  value: string
}

type DastParagrah = {
  type: "paragraph",
  children: DastSpan[]
}

type DastHeading = {
  type: "heading",
  level: number,
  children: DastSpan[]
}

type DastListItem = {
  type: "listItem",
  children: DastParagrah[]
}

type DastList = {
  type: "list",
  style: "bulleted"
  children: DastListItem[]
} 

type DastElement = DastParagrah | DastHeading | DastList;

type DastDocumnet = {
  type: "root",
  children: DastElement[]
}

export type Dast = {
  schema: "dast"
  document: DastDocumnet
}

export function createEmptyDust(): Dast {
  return {
    schema: "dast",
    document: {
      type: "root",
      children: []
    }
  }
}

export function createParagraphs(paragraphContents: string[]): DastParagrah[] {
  return paragraphContents.map((line) => {
    return {
      type: "paragraph",
      children: [
        {
          type: "span",
          value: line
        }
      ]
    }
  });
}

export function createSimpleTextDast(paragraphContents: string[]): Dast {
  const paragraphs: DastParagrah[] = createParagraphs(paragraphContents);
  return {
    schema: "dast",
    document: {
      type: "root",
      children: paragraphs
    }
  }
}

export function createEnumerationDast(bulletpointContents: string[]): Dast {
  const listItems: DastListItem[] = bulletpointContents.map((line) => {
    return {
      type: "listItem",
      children: createParagraphs([line])
    }
  });
  return {
    schema: "dast",
    document: {
      type: "root",
      children: [
        {
          type: "list",
          style: "bulleted",
          children: listItems
        } 
      ]
    }
  }
}

export function createSimpleTitleDast(titleText: string): Dast {
  return {
    schema: "dast",
    document: {
      type: "root",
      children: [
        {
          type: "heading",
          level: 1,
          children: [
            {
              type: "span",
              value: titleText
            }
          ]
        }
      ]
    }
  }
}
